import { MqttMixin } from '../mixins/MqttMixin';
import { mapState } from 'vuex';

export const DeviceMixin = {
    mixins: [MqttMixin],
    props: {
        device: Object,
    },
    data() {
        return {
            programs: [],
        };
    },

    methods: {
        togglePowerDevice(status) {
            this.status.setPower(status);

            this.toggleAC(status);
            /*if (this.isChangeMode()) this.toggleAC(true);*/
            //else this.setPower(this.installation_ref, this.reference, value, (data) => dd(data));
        },

        updateOrder: function(order) {
            this.status.setOrder(order);
            this.$uniqueSetTimeout(
                'updateOrder',
                () => {
                    this.setTemp(this.installation_ref, this.reference, order, (data) => dd(data));
                },
                1000
            );
        },
        updateFanMode: function(mode) {
            this.status.setFanMode(mode);
            this.setFanspeed(this.installation_ref, this.reference, mode, (data) => dd(data));
        },
        toggleAC: function(mode) {
            this.setModeHeat(mode, this.status.isModeFloor());
        },
        toggleRadiatingFloor: function(mode) {
            this.status.setFloor(mode);
            this.setModeHeat(this.status.isModeAC(), mode);
        },
        setModeHeat: function(ac, floor) {
            if (!ac && !floor) return this.setPower(this.installation_ref, this.reference, '0', (data) => dd(data));

            this.status.setMode(this.status.isModeHeat(), ac, floor);
            this.status.setPower(true);

            this.setMode(
                this.installation_ref,
                this.reference,
                { mode: this.status.getMode(), temperature: this.status.getOrder() },
                (data) => {
                    dd(data);
                }
            );
        },
        updateTimer: function(time) {
            this.status.setTimer(time);
            this.setTemporizer(this.installation_ref, this.reference, time, (data) => dd(data));
        },
    },
    computed: {
        reference: function() {
            return this.data.reference;
        },
        installation_ref: function() {
            return this.data.installation_ref;
        },
        data: function() {
            return this.device || {};
        },
        ...mapState({
            statusInstallation(state) {
                return state.globalStatus[this.installation_ref] || {};
            },
            space(state) {
                return state.spaces[this.device.space_id] || {};
            },
            location(state) {
                return state.locations[this.space.location_id] || {};
            },
        }),
        status() {
            return this.statusInstallation.getDevice(this.reference);
        },
    },
};
